import { withDevtools, withGlitchTracking, withStorageSync } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import { INITIAL_APP_STORE_STATE } from '@navstation-portal/reporting/data-model/app';
import { signalStore, withComputed, withState } from '@ngrx/signals';
import { withAppReducer } from './with-app-reducer';

const APP_STORE_ID = 'AppStore';

export const AppStore = signalStore(
  { providedIn: 'root' },
  withDevtools(APP_STORE_ID, withGlitchTracking()),
  withState(INITIAL_APP_STORE_STATE),
  withStorageSync({
    key: APP_STORE_ID,
    select: (state) => ({
      selectedVesselId: state.selectedVesselId,
      defaultVesselId: state.defaultVesselId,
      selectedVessel: state.selectedVessel,
    }),
  }),
  withAppReducer(),
  withComputed((store) => {
    return {
      vm: computed(() => {
        const defaultVesselId = store.defaultVesselId();
        const selectedVesselId = store.selectedVesselId();
        return {
          selectedVesselId: selectedVesselId || defaultVesselId,
        };
      }),
    };
  })
);
